import React from 'react';
import DetailRow from '../../common/DetailRow';
import Note from '../../common/Note';
import { Card, CardBody, SectionTitle } from '../../common/Card';
import {
  formatGapFeeDisplay,
  formatMedicareRebateDisplay,
  formatTotalFeeDisplay,
} from '../../../utils/feeUtils';
import { EstimateNote, EstimateTag } from './styles';

const FeeSummary = ({ fee }) => {
  const totalFeeDisplay = formatTotalFeeDisplay(fee);
  const medicareRebateDisplay = formatMedicareRebateDisplay(fee);
  const gapFeeDisplay = formatGapFeeDisplay(fee);
  const hasAnyFee = Boolean(
    totalFeeDisplay || medicareRebateDisplay || gapFeeDisplay
  );

  if (!fee || !hasAnyFee) return null;

  return (
    <Card>
      <CardBody>
        <SectionTitle>Consultation Fees:</SectionTitle>

        {totalFeeDisplay && (
          <DetailRow label="Total Fee" value={totalFeeDisplay} nowrap />
        )}

        {medicareRebateDisplay && (
          <DetailRow
            label="Medicare Rebate"
            subLabel="May vary based on your eligibility"
            value={medicareRebateDisplay}
            nowrap
          />
        )}

        {gapFeeDisplay && (
          <DetailRow
            label="Out of Pocket (Gap Fee)"
            badge={<EstimateTag>Estimate</EstimateTag>}
            value={gapFeeDisplay}
            currency="AUD"
            emphasised
            stacked
          />
        )}

        <EstimateNote>
          <Note>
            <b>This amount is an estimate.</b> The Medicare item number is
            decided by your clinician at the end of the consultation, based on
            the type of consultation you have. If it changes your rebate, our
            admin team will contact you to confirm the final amount with you.
          </Note>
        </EstimateNote>
      </CardBody>
    </Card>
  );
};

export default FeeSummary;
